<template>
  <div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>{{ $t('new_user') }}</h4>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/users" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <form @submit.prevent="saveUser" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{$t('user_name')}} <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="form.username"
                      class="form-control"
                      :placeholder="$t('enter_user_name')"
                    />
                    <div v-if="errors.username" class="text-danger mt-1">{{ errors.username }}</div>
                  </div>

                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{$t('email')}} </label>
                    <input
                      type="email"
                      v-model="form.email"
                      class="form-control"
                      :placeholder="$t('enter_email')"
                    />
                    <div v-if="errors.email" class="text-danger mt-1">{{ errors.email }}</div>
                  </div>

                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{$t('phone_number')}}</label>
                    <input
                      type="text"
                      v-model="form.phone_number"
                      class="form-control"
                      :placeholder="$t('enter_phone_number')"
                    />
                    <div v-if="errors.phone_number" class="text-danger mt-1">{{ errors.phone_number }}</div>
                  </div>

                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("password") }} </label>
                    <input
                      type="password"
                      v-model="form.password"
                      class="form-control"
                      :placeholder="$t('enter_password')"
                    />
                    <div v-if="errors.password" class="text-danger mt-1">{{ errors.password }}</div>
                  </div>

                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("confirm_password") }} </label>
                    <input
                      type="password"
                      v-model="form.confirm_password"
                      class="form-control"
                      :placeholder="$t('enter_confirm_password')"
                    />
                    <div v-if="errors.confirm_password" class="text-danger mt-1">
                      {{ errors.confirm_password }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <label class="form-label small mb-0 me-3" style="width:100px;">{{ $t('store_name') }} <span class="text-danger">*</span></label>
                      <VueSelect2
                        v-model="form.store_id"
                        :options="formattedstores"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                          tags: true,
                        }"
                        @change="onChange"
                        class="form-control"
                      />
                    </div>
                    <div class="text-danger mt-1" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
                      <span v-if="errors.store_id">{{ errors.store_id }}</span>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <label class="form-label small mb-0 me-3" style="width:100px;">{{ $t('role_name') }} <span class="text-danger">*</span></label>
                      <VueSelect2
                        v-model="form.role_id"
                        :options="formattedroles"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                          tags: true,
                        }"
                        @change="onChange"
                        class="form-control"
                      />
                    </div>
                    <div class="text-danger mt-1" style="height:0.75em; margin-left: 150px; font-size:0.875rem;">
                      <span v-if="errors.role_id">{{ errors.role_id }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 text-end">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </div>
  </form>
</div>
</template>

<script>
import apiUrls from "@/urls";
import VueSelect2 from "vue3-select2-component";
import {useToast} from "vue-toastification";
import Vue3Datepicker from "vue3-datepicker";


export default {
  components: {
    Vue3Datepicker,
    VueSelect2,
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      form: {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        store_id: null,
        role_id: null,
        phone_number: ''
      },

      errors: {},
      loading: false,

      stores: [],
      roles: [],
    };
  },

  async created() {
    this.stores = (await this.$axios.get(apiUrls.inventory_store.get)).data;
    this.roles = (await this.$axios.get(apiUrls.roles.get)).data;
  },

  computed: {
    formattedstores() {
      return this.stores.map(store => ({ id: store.id, text: store.name }));
    },

    formattedroles() {
      return this.roles.map(role => ({ id: role.id, text: role.name }));
    },
  },

  methods: {
    async saveUser() {
      this.loading = true;
      this.errors = {};
      if (!this.form.username.trim()) this.errors.username = this.$t('error.required');
      if (!this.form.password.trim()) this.errors.password = this.$t('error.required');

      if (!this.form.confirm_password) {
        this.errors.confirm_password = this.$t("error.required");
      }

      // Password match validation
      if (
        this.form.password &&
        this.form.confirm_password &&
        this.form.password !== this.form.confirm_password
      ) {
        this.errors.confirm_password = this.$t("password_not_match");
      }

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      const payload = { ...this.form };
      delete payload.confirm_password;

      try {
        await this.$axios.post(apiUrls.users.get, payload);

        this.toast.success('User successfully created!')

        this.resetForm();

        this.$router.push("/users");

      } catch (error) {
        if (error.response) {
          const status = error.response.status;

          if (status === 400) {
            this.errors = error.response.data || {};
          }
          else if (status === 401 || status === 403) {
            alert(this.$t("permission_denied"));
          }
          else {
            alert(this.$t("something_went_wrong"));
          }
        } else {
          alert(this.$t("network_error"));
        }
      } finally {
        this.loading = false;
      }
    },

    cancelForm() {
      this.$router.push('/users');
    },

    resetForm() {
      this.form = {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        store_id: null,
        role_id: null,
        phone_number: ''
      };
      this.errors = {};
    },
  },
};
</script>
